import * as React from 'react';
import Head from 'next/head';
import Script from 'next/script';
import {
  getPractitionersContentfulData,
  PractitionersContentfulData,
} from 'lib/contentful/practitioners/get-practitioners-contentful-data';
import { useHashAccountInfo } from 'hooks/use-hash-account-info';

import HeaderFullscript from 'components/pages/practitioners/header-fullscript';
import PatientCareHero from 'components/pages/practitioners/patient-care-hero';
import ConnectCta from 'components/pages/practitioners/connect-cta';
import Benefits from 'components/pages/practitioners/benefits';
import RecommendOnFullscript from 'components/pages/practitioners/recommend-on-fullscript';
import GrowWithSeed from 'components/pages/practitioners/grow-with-seed';
import BoardMembers from 'components/pages/practitioners/board-members';
import MicrobialInnovation from 'components/pages/practitioners/microbial-innovation';
import FormHcpNew from 'components/form/form-hcp-new';
import HcpFooter from 'components/pages/practitioners/hcp-footer';
import Url from 'lib/siteurls';

import PractitionersLocale from 'locale/en/practitioners.json';
import MiscLocale from 'locale/en/misc.json';

const PageData = {
  page_title: PractitionersLocale.page_title,
  page_description: PractitionersLocale.page_desc,
};

const PageHead = () => (
  <>
    <Head>
      <title>{`${MiscLocale.brand} • ${PageData.page_title}`}</title>
      <meta name='description' content={PageData.page_description} />
    </Head>
    <Script src={Url.recaptcha} strategy='afterInteractive' />
  </>
);

type PageHcpLpProps = PractitionersContentfulData;

const PageHCPLPApp: React.FC<PageHcpLpProps> = ({
  benefitsSection,
  boardMembersSection,
  footerSection,
}) => {
  const { hashedAccountInfo } = useHashAccountInfo();
  return (
    <>
      <PageHead />
      <HeaderFullscript hashedAccountInfo={hashedAccountInfo} />
      <PatientCareHero />
      <ConnectCta hashedAccountInfo={hashedAccountInfo} />
      <Benefits
        benefits={benefitsSection.benefits}
        description={benefitsSection.description}
      />
      <RecommendOnFullscript />
      <GrowWithSeed />
      <BoardMembers boardMembers={boardMembersSection.boardMembers} />
      <MicrobialInnovation />
      <FormHcpNew />
      <HcpFooter disclaimer={footerSection.disclaimer} />
    </>
  );
};

export const getStaticProps = async () => {
  const { benefitsSection, boardMembersSection, footerSection } =
    await getPractitionersContentfulData();

  return {
    props: {
      benefitsSection,
      boardMembersSection,
      footerSection,
      pageLayout: 'blank',
    },
    revalidate: 60 * 60, // One hour in seconds
  };
};

export default PageHCPLPApp;
